import React, { useState } from "react";
import { Table, Typography, Button, Tooltip } from "antd";
import { FormattedMessage } from "react-intl";
import {
  SearchOutlined,
  PrinterOutlined,
  MailOutlined,
} from "@ant-design/icons";
import FullScreenModal from "../../../components/templates/FullScreenModal";
import WorkDiary from "../../workDiary/index";
import { useIntl } from "react-intl";
import { sendDiaryToEmployee } from "../employeeWorkDiariesSlice";
import { useDispatch, useSelector } from "react-redux";
import { getFullName } from "../../../components/util/helpers";
import { getDiary, loadImage } from "../../../components/util/helpers";
import jsPDF from "jspdf";
import moment from "moment";

const { Text } = Typography;
const DiariesTable = (props) => {
  const { currentDate, diaries } = props;
  const intl = useIntl();
  const dispatch = useDispatch();
  const [visible, setVisible] = useState(false);
  const [activeDiary, setActiveDiary] = useState(null);
  const { activeYear, activeMonth } = useSelector(
    (state) => state.employeeWorkDiaries
  );
  const organization = useSelector((state) => state.organization.details);

  const loading = useSelector(
    (state) => state.pendingActions["employeeWorkDiaries/load"]
  );
  const sendDiaryLoading = useSelector(
    (state) => state.pendingActions["employeeWorkDiaries/sendDiary"]
  );

  const setDiary = (record) => {
    setActiveDiary(record);
  };

  const onShow = (record) => {
    setDiary(record);
    setVisible(true);
  };

  const onHide = () => {
    setVisible(false);
  };

  const onPrintPdf = async (record) => {
    const avatar_url = organization.avatar_url;
    const logo = await loadImage(avatar_url);
    let diaryPdf = new jsPDF({ orientation: "p" });
    const pdf = getDiary(
      diaryPdf,
      intl,
      record,
      organization,
      currentDate,
      logo
    );
    window.open(pdf.output("bloburl"), "_blank");
  };
  const onSendPdf = async (record) => {
    const avatar_url = organization.avatar_url;
    const logo = await loadImage(avatar_url);
    let diaryPdf = new jsPDF({ orientation: "p" });
    const pdf = getDiary(
      diaryPdf,
      intl,
      record,
      organization,
      currentDate,
      logo
    );

    var base64result = pdf
      .output("datauristring")
      .substr(pdf.output("datauristring").indexOf(",") + 1);
    const fileName = `יומן עבודה_${getFullName(
      record.patient.surename,
      record.patient.first_name
    )}_${moment(currentDate).format("MM/YYYY")}.pdf`;
    const params = {
      email: record.employee.contact_info.email,
      month: +moment(currentDate).format("M"),
      year: +moment(currentDate).format("YYYY"),
      attachments: [base64result],
      attachment_names: [fileName],
      order_ids: [record.order.id],
      employeeId: record.employee_id,
    };

    dispatch(sendDiaryToEmployee(params));
  };

  const columns = [
    {
      title: <FormattedMessage id="app.work_diary.clientName" />,
      dataIndex: "order",
      width: "200px",
      render(text, record) {
        return <Text>{text.client.name}</Text>;
      },
    },
    {
      title: <FormattedMessage id="app.work_diary.patientName" />,
      dataIndex: "patient",
      width: "200px",
      render(text, record) {
        return <Text>{getFullName(text.surename, text.first_name)}</Text>;
      },
    },
    {
      title: <FormattedMessage id="app.work_diary.month" />,
      dataIndex: "month",
      width: "200px",
      render(text, record) {
        return <Text>{`${activeMonth}/${activeYear}`}</Text>;
      },
    },
    {
      title: <FormattedMessage id="app.work_diary.actions" />,
      responsive: ["md"],
      width: "100px",
      render: (record) => (
        <div style={{ display: "flex" }}>
          <Tooltip
            title={intl.formatMessage({
              id: "app.work_diary.showDiary",
            })}
          >
            <Button
              type="text"
              icon={<SearchOutlined />}
              onClick={() => onShow(record)}
            />
          </Tooltip>
          <Tooltip
            title={intl.formatMessage({
              id: "app.work_diary.printDiary",
            })}
          >
            <Button
              type="text"
              icon={<PrinterOutlined />}
              onClick={() => onPrintPdf(record)}
            />
          </Tooltip>
          {record.employee.agree_to_recieve_email && (
            <Tooltip
              title={intl.formatMessage({
                id: "app.work_diary.sendDiary",
              })}
            >
              <Button
                type="text"
                icon={<MailOutlined />}
                onClick={() => onSendPdf(record)}
                loading={sendDiaryLoading}
              />
            </Tooltip>
          )}
        </div>
      ),
    },
  ];
  return (
    <div>
      <div
        style={{
          overflow: "hidden",
          height: 0,
          width: 0,
          position: "absolute",
        }}
      ></div>
      <Table
        bordered
        columns={columns}
        dataSource={diaries}
        rowKey={(record) => record.order_id}
        scroll={{ y: window.innerHeight - 546 }}
        loading={loading}
        pagination={false}
      />
      <FullScreenModal visible={visible} onHide={onHide}>
        {activeDiary && (
          <WorkDiary activeRecord={activeDiary} currentDate={currentDate} />
        )}
      </FullScreenModal>
    </div>
  );
};

export default DiariesTable;
